// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build -- --configuration=production` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  ga: null,
  localVersionData: null,
  MSAL_AUTHORITY: 'https://{tenantId}.b2clogin.com/{tenantId}.onmicrosoft.com/{policyId}',
  MSAL_KNOWN_AUTHORITY_DOMAIN: "{tenantId}.b2clogin.com",
  MSAL_SIGNIN_FLOW: "B2C_1_SignIn",
  MSAL_FORGET_PASSWORD_FLOW: "B2C_1_PasswordReset",
  MSAL_SIGNUP_FLOW: "B2C_1_SignUp",
};
